var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "scope-arrangement-setting container"
  }, [_c('div', {
    staticClass: "box-shadow-small border-radius",
    staticStyle: {
      "padding-bottom": "40px"
    }
  }, [_c('div', {}, [_c('div', {
    staticStyle: {
      "padding-top": "30px"
    }
  }, [_c('thumbnail', {
    attrs: {
      "text": _vm.baseInfo.name,
      "gender": _vm.baseInfo.gender === 1 ? 'man' : 'woman',
      "font-size": 16,
      "width": 110
    }
  }), _vm._v(" "), _c('el-row', {
    staticClass: "mt-10 text-center",
    attrs: {
      "gutter": 10
    }
  }, [_c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_vm._v("应聘职位：" + _vm._s(_vm.baseInfo.positionName))]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_vm._v("应聘部门：" + _vm._s(_vm.baseInfo.deptNames))]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_vm._v("手机号：" + _vm._s(_vm.baseInfo.phone))])], 1)], 1)]), _vm._v(" "), (_vm.baseInfo.paperName) ? [_c('div', {
    staticClass: "mt-25"
  }, [_c('div', {
    staticClass: "el-table el-table--fit el-table--border el-table--enable-row-transition"
  }, [_c('table', {
    staticClass: "el-table__body",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('tr', {
    staticClass: "el-table__row"
  }, [_vm._m(0), _vm._v(" "), _c('td', {
    staticClass: "is-center"
  }, [_c('div', {
    staticClass: "cell"
  }, [_vm._v(_vm._s(_vm.baseInfo.examName || '-'))])])]), _vm._v(" "), _c('tr', {
    staticClass: "el-table__row"
  }, [_vm._m(1), _vm._v(" "), _c('td', {
    staticClass: "is-center"
  }, [_c('div', {
    staticClass: "cell"
  }, [_vm._v(_vm._s(_vm.baseInfo.examRules || '-'))])])]), _vm._v(" "), _c('tr', {
    staticClass: "el-table__row"
  }, [_vm._m(2), _vm._v(" "), _c('td', {
    staticClass: "is-center"
  }, [_c('div', {
    staticClass: "cell"
  }, _vm._l((_vm.baseInfo.paperList), function(item, index) {
    return _c('p', {
      key: index
    }, [_vm._v(_vm._s(item.name))])
  }), 0)])]), _vm._v(" "), _c('tr', {
    staticClass: "el-table__row"
  }, [_vm._m(3), _vm._v(" "), _c('td', {
    staticClass: "is-center"
  }, [_c('div', {
    staticClass: "cell"
  }, _vm._l((_vm.baseInfo.examTimes), function(item, index) {
    return _c('p', {
      key: index
    }, [_vm._v("\n                                        " + _vm._s(item.startTime) + " - " + _vm._s(item.endTime))])
  }), 0)])])])])]), _vm._v(" "), _c('div', {
    staticClass: "mt-25"
  }, [_c('div', {
    staticClass: "el-table el-table--fit el-table--border el-table--enable-row-transition"
  }, [_c('table', {
    staticClass: "el-table__body",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('tr', {
    staticClass: "el-table__row"
  }, [_vm._m(4), _vm._v(" "), _c('td', {
    staticClass: "is-center",
    attrs: {
      "width": "180",
      "colspan": "2"
    }
  }, [_c('div', {
    staticClass: "cell"
  }, [_vm._v(_vm._s(_vm.baseInfo.privateScoreTotal || '-'))])]), _vm._v(" "), _vm._m(5), _vm._v(" "), _c('td', {
    staticClass: "is-center"
  }, [_c('div', {
    staticClass: "cell"
  }, [_vm._v(_vm._s(_vm.baseInfo.paperName || '-'))])]), _vm._v(" "), _vm._m(6), _vm._v(" "), _c('td', {
    staticClass: "is-center",
    attrs: {
      "width": "250"
    }
  }, [_c('div', {
    staticClass: "cell"
  }, [_vm._v(_vm._s(_vm.baseInfo.startTime) + " -  " + _vm._s((_vm.baseInfo.endTime || '').substring(11)))])])]), _vm._v(" "), _vm._m(7), _vm._v(" "), _vm._l((_vm.baseInfo.markExamList), function(item, index) {
    return _c('tr', {
      key: index,
      staticClass: "el-table__row"
    }, [_c('td', {
      staticClass: "is-center"
    }, [_c('div', {
      staticClass: "cell"
    }, [_vm._v(_vm._s(item.markName || '-'))])]), _vm._v(" "), _c('td', {
      staticClass: "is-center"
    }, [_c('div', {
      staticClass: "cell"
    }, [_vm._v(_vm._s(item.privateScore || '-'))])]), _vm._v(" "), _c('td', {
      staticClass: "is-center"
    }, [_c('div', {
      staticClass: "cell"
    }, [_vm._v(_vm._s(item.score || '-'))])]), _vm._v(" "), _c('td', {
      staticClass: "is-center"
    }, [_c('div', {
      staticClass: "cell"
    }, [_vm._v(_vm._s(item.result))])]), _vm._v(" "), _c('td', {
      staticClass: "is-center",
      attrs: {
        "colspan": "3"
      }
    }, [_c('div', {
      staticClass: "cell"
    }, [_vm._v(_vm._s(item.remark))])])])
  })], 2)])])] : _c('empty-tip')], 2)])
}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', {
    staticClass: "is-center",
    attrs: {
      "width": "240"
    }
  }, [_c('div', {
    staticClass: "cell"
  }, [_vm._v("考试标题")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', {
    staticClass: "is-center"
  }, [_c('div', {
    staticClass: "cell"
  }, [_vm._v("考试须知")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', {
    staticClass: "is-center"
  }, [_c('div', {
    staticClass: "cell"
  }, [_vm._v("选择笔试题")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', {
    staticClass: "is-center"
  }, [_c('div', {
    staticClass: "cell"
  }, [_vm._v("考试日期")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', {
    staticClass: "is-center",
    attrs: {
      "width": "120"
    }
  }, [_c('div', {
    staticClass: "cell"
  }, [_vm._v("系统评分总分")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', {
    staticClass: "is-center",
    attrs: {
      "width": "120"
    }
  }, [_c('div', {
    staticClass: "cell"
  }, [_vm._v("答卷")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', {
    staticClass: "is-center",
    attrs: {
      "width": "150"
    }
  }, [_c('div', {
    staticClass: "cell"
  }, [_vm._v("答卷时间段")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', {
    staticClass: "el-table__row"
  }, [_c('td', {
    staticClass: "is-center",
    staticStyle: {
      "background": "#eee"
    }
  }, [_c('div', {
    staticClass: "cell"
  }, [_vm._v("评估人")])]), _vm._v(" "), _c('td', {
    staticClass: "is-center",
    staticStyle: {
      "background": "#eee"
    }
  }, [_c('div', {
    staticClass: "cell"
  }, [_vm._v("系统评分")])]), _vm._v(" "), _c('td', {
    staticClass: "is-center",
    staticStyle: {
      "background": "#eee"
    }
  }, [_c('div', {
    staticClass: "cell"
  }, [_vm._v("面试官评分")])]), _vm._v(" "), _c('td', {
    staticClass: "is-center",
    staticStyle: {
      "background": "#eee"
    }
  }, [_c('div', {
    staticClass: "cell"
  }, [_vm._v("状态")])]), _vm._v(" "), _c('td', {
    staticClass: "is-center",
    staticStyle: {
      "background": "#eee"
    },
    attrs: {
      "colspan": "3"
    }
  }, [_c('div', {
    staticClass: "cell"
  }, [_vm._v("备注")])])])
}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-657e0bcf"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/written/writtenPersonDetail.vue
// module id = null
// module chunks = 